import React from 'react';
import { PDFViewer, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import Cover from '../../Components/GeneratePdf/Cover';
import LeadershipPage1 from '../../Components/GeneratePdf/Leadership/LeadershipPage1';
import LeadershipPage2 from '../../Components/GeneratePdf/Leadership/LeadershipPage2';
import LeadershipPage3 from '../../Components/GeneratePdf/Leadership/LeadershipPage3';
import MindSetPage from '../../Components/GeneratePdf/MindSetPage';
import MindSetPage2 from '../../Components/GeneratePdf/MindSetPage2';
import MindSetPage3 from '../../Components/GeneratePdf/MindSetPage3';
import AccToPageHeading from "../../Components/GeneratePdf/AccToPageHeading";
import HeartPage from "../../Components/GeneratePdf/HeartPage";
import RelectAndIntegrate1 from '../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate1';
import RelectAndIntegrate2 from '../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate2';
import LifeIntegration1 from '../../Components/GeneratePdf/LifeIntegration/LifeIntegration1';
import LifeIntegration2 from '../../Components/GeneratePdf/LifeIntegration/LifeIntegration2';
import SoulPage from "../../Components/GeneratePdf/SoulPage";
import MindPage from "../../Components/GeneratePdf/MindPage";
import StrengthPage from "../../Components/GeneratePdf/StrengthPage"

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 30,
  },
  page2: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 20,
  },
  pagespace: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 21,
    height: 792,
    justifyContent: 'space-between'
  },
});



// Create Document Component
const MyDocument = () => (
  <Document>
    <Page size={{ width: 612, height: 792 }} style={styles.page}>
      <Cover />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <AccToPageHeading />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <HeartPage />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <SoulPage />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <MindPage />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <StrengthPage />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <MindSetPage />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <MindSetPage2 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <MindSetPage3 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <RelectAndIntegrate1 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <RelectAndIntegrate2 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <LifeIntegration1 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.page2}>
      <LifeIntegration2 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.pagespace}>
      <LeadershipPage1 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.pagespace}>
      <LeadershipPage2 />
    </Page>
    <Page size={{ width: 612, height: 792 }} style={styles.pagespace}>
      <LeadershipPage3 />
    </Page>

  </Document>
);

function GeneratePdf() {
  return (
    <div style={{ width: "1440px" }}>
      <h1>PDF Generator</h1>
      <PDFViewer width="100%" height="600px">
        <MyDocument />
      </PDFViewer>
    </div>
  );
}

export default GeneratePdf;